import { atomWithStorage } from 'jotai/utils';

export type OfflineStatus = 'downloading' | 'ready' | 'partial' | 'stale' | 'error';

export interface CatalogEntry {
  projectId: string;
  status: OfflineStatus;
  totalBytes: number;
  downloadedBytes: number;
  /** layerId -> server `updatedAt` ISO string captured at download time. */
  layerVersions: Record<string, string>;
  downloadedAt: string;
  error?: string;
  /** Storage keys of every downloaded file, for targeted per-project removal. */
  fileKeys?: string[];
}

export type OfflineCatalog = Record<string, CatalogEntry>;

/** Persisted in localStorage (small JSON — the bytes live in OPFS). */
export const offlineCatalogAtom = atomWithStorage<OfflineCatalog>('offline.catalog.v1', {});

/**
 * A cached project is stale if the set of layers or any layer's `updatedAt`
 * differs from what the server currently reports.
 */
export function isStale(entry: CatalogEntry, serverLayerVersions: Record<string, string>): boolean {
  const cached = entry.layerVersions;
  const cachedIds = Object.keys(cached);
  const serverIds = Object.keys(serverLayerVersions);
  if (cachedIds.length !== serverIds.length) return true;
  for (const id of serverIds) {
    if (cached[id] !== serverLayerVersions[id]) return true;
  }
  return false;
}
